// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__32dhD","bigColWidth":"Table_bigColWidth__2pkLe","biggerColWidth":"Table_biggerColWidth__V3N6F","row":"Table_row__2Olbq","col":"Table_col__3NKKe"};